import {ChangeDetectorRef, Component, OnDestroy, OnInit} from "@angular/core";
import {EntityData, provideEntityModel} from "@fedeltapointofsale/data-client";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {CustomObjectEntityModel} from "../custom-object-entity.model";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {Subscription} from "rxjs";
import {CustomObjectData, CustomObjectFieldValueData} from "../custom-object.data";
import {CustomObjectTypeData} from "../../custom-object-type/custom-object-type.data";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-custom-object-edit-page",
    templateUrl: "./custom-object-edit-page.component.html",
    providers: [provideEntityModel(CustomObjectEntityModel)]
})
export class CustomObjectEditPageComponent extends AbstractEditPage implements OnInit, OnDestroy {
    EditMode = EditMode;

    productLineContext: boolean = false;
    inventoryContext: boolean = false;
    outletContext: boolean = false;
    membershipTypeContext: boolean = false;
    groupTypeLocked: boolean = false;

    private saving: boolean = false;
    private merging: boolean = false;
    private subscriptions: Subscription = new Subscription();
    private fieldValuesReadySubscription: Subscription;
    private typeLoadedSubscription: Subscription;
    private retainedFieldValues: CustomObjectFieldValueData[] = [];

    constructor(public model: CustomObjectEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
        this.subscriptions.add(this.model.$data.subscribe(() => {
            if (this.fieldValuesReadySubscription) {
                this.fieldValuesReadySubscription.unsubscribe();
            }
            this.fieldValuesReadySubscription = this.model.$collectionLoaded("customObjectFieldValues").subscribe(() => this.mergeCustomFields());
            if (this.typeLoadedSubscription) {
                this.typeLoadedSubscription.unsubscribe();
            }
            this.typeLoadedSubscription = this.model.$componentLoaded("customObjectType").subscribe(() => this.mergeCustomFields());
        }));
    }

    stripUnusedCustomFields(): void {
        this.retainedFieldValues = this.retainedFieldValues
            .filter((retainedFieldValue: CustomObjectFieldValueData) => !this.model.data.customObjectFieldValues.find((fieldValue: CustomObjectFieldValueData) => fieldValue.fieldName === retainedFieldValue.fieldName));
        this.model.data.customObjectFieldValues = this.model.data.customObjectFieldValues
            .filter((fieldValue: CustomObjectFieldValueData) => fieldValue.fieldValue && fieldValue.fieldValue.trim());
        this.retainedFieldValues = this.retainedFieldValues.concat(this.model.data.customObjectFieldValues
            .filter((fieldValue: CustomObjectFieldValueData) => !this.model.data.customObjectType.customFields.includes(fieldValue.fieldName)));
        this.model.data.customObjectFieldValues = this.model.data.customObjectFieldValues
            .filter((fieldValue: CustomObjectFieldValueData) => this.model.data.customObjectType.customFields.includes(fieldValue.fieldName));
    }

    mergeCustomFields(): void {
        if (this.merging || this.saving) {
            return;
        }
        this.merging = true;
        this.model.data.customObjectFieldValues = this.model.data.customObjectFieldValues.concat(this.retainedFieldValues);
        this.stripUnusedCustomFields();
        this.model.data.customObjectType.customFields.forEach((name: string) => {
            if (!this.model.data.customObjectFieldValues.find((fieldValue: CustomObjectFieldValueData) => fieldValue.fieldName == name)) {
                const fieldValue: CustomObjectFieldValueData = <CustomObjectFieldValueData> EntityData.create(CustomObjectFieldValueData);
                fieldValue.fieldName = name;
                this.model.data.customObjectFieldValues.push(fieldValue);
            }
        });
        this.model.data.customObjectFieldValues.sort((a: CustomObjectFieldValueData, b: CustomObjectFieldValueData) => a.fieldName.localeCompare(b.fieldName));
        this.merging = false;
    }

    handleSave(): void {
        this.saving = true;
        this.stripUnusedCustomFields();
        this.saving = false;
    }

    customObjectTypeSelected(): void {
        this.editPageComponent.formGroup.get("name").updateValueAndValidity();
    }

    customObjectTypeCleared(): void {
        this.stripUnusedCustomFields();
    }

    ngOnInit(): void {
        if (this.editPageComponent.stackedPageContextService && this.editPageComponent.stackedPageContextService.params.parentEntity) {
            const customObjectType: CustomObjectTypeData = this.editPageComponent.stackedPageContextService.params.parentEntity;

            // This will cause a reload of the customObjectType
            this.model.data.customObjectType = customObjectType;
            this.groupTypeLocked = true;
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
        if (this.fieldValuesReadySubscription) {
            this.fieldValuesReadySubscription.unsubscribe();
        }
        if (this.typeLoadedSubscription) {
            this.typeLoadedSubscription.unsubscribe();
        }
    }

    addingAnother(previousEntity: CustomObjectData): void {
        this.model.data.customObjectType.customObjectTypeId = previousEntity.customObjectType.customObjectTypeId
    }
}
